import React from 'react';
import { useBlogDetail } from './../../queries/blogDetail';
import ToolBarMenu from './../../components/ToolBarMenu/index';
import Header from './../../components/Header/index';
import PageHeader from './../../components/PageHeader/index';
import PageWrapper from './../../components/PageWrapper/index';
import Footer from './../../components/Footer/index';
import {getImagesWithAbsolutePath, myDomain} from '../../helpers/urlHelper';
import { useParams } from 'react-router-dom';
import profileImage from './../../assets/img/profileIcon.jpg';
import InfinitProgressBar from '../../components/InfiniteProgressBar';
import moment from 'jalali-moment'
const BlogsDetail = () => {

    
    const params = new useParams();
    const BlogtInfo = useBlogDetail(params.id);
    if (BlogtInfo.error) return <div>error!</div>
    if (BlogtInfo.loading) return <InfinitProgressBar />

    

    return (  BlogtInfo.data ?

        <>
            {/* <ToolBarMenu/> */}
            <Header/>
            <PageHeader
                bgImg={BlogtInfo.data.blog[0].blogPageHeaderImage.urls[0]}
                content=''
                title={BlogtInfo.data.blog[0].displayText}
            />

            <PageWrapper classes={'product-details-wrapper sm-top'}>
                <div className="col-12">
                    <article className="blog-post-details">
                        <div className="blog-post-txt-wrap">
                            <div className="row">
                                
                                <div className="col-md-3 col-lg-2 order-1 order-md-0">
                                    <div className="author-info mt-sm-40">
                                        <div className="author-thumb" style={{padding:"10%"}}>
                                            <img src={profileImage} alt='pslogo'/>
                                        </div>
                                        <div className="author-txt">
                                            <h5>{BlogtInfo.data.blog[0].blogAuthor}</h5>
                                            <br/>
                                            <h4>{moment(BlogtInfo.data.blog[0].blogCreateDate, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD') }</h4>
                                        </div>
                                    </div>
                                </div>
                                    
                                <div className={`m-auto order-0 col-md-12 col-lg-8`}>
                                    <div className="blog-post-txt">
                                    <h3>{BlogtInfo.data.blog[0].displayText}</h3>
                                        <div dangerouslySetInnerHTML={{__html: getImagesWithAbsolutePath(BlogtInfo.data.blog[0].htmlBody.html, myDomain)}} />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </article>
                </div>
            </PageWrapper>
            <br/>
            <br/>
            <br/>
            <Footer/>
        </>
        

    : null);
}
 
export default BlogsDetail;